'use client';

// base
import React, { useState } from 'react';
import Image from 'next/image';

// styles
import { StyledMainHeader } from './style';

// constants
import { ciImage, commonImage, menuIcons } from 'constants/images';
import { BasicLabel, BasicModal, BasicSelect, TextButton } from 'components';
import { Column, Row } from 'styles';
import { cookieStorage, STORAGE_LOCAL_USER_ID, storageService } from 'services';
import { useRouter } from 'next/navigation';
import { PkgType, useCheckPkgUser, useFetchOtp } from 'domains/Pkg';
import { SignUp } from 'domains/Auth/containers/SignUp';
import { UserDetail } from 'domains/Admin';

interface MainHeaderProps {
  collapsed: boolean;
  onChangeCollapsed: () => void;
}

export const MainHeader: React.FC<MainHeaderProps> = ({ collapsed, onChangeCollapsed }) => {
  const [isAlarmModal, setIsAlarmModal] = useState(false);
  const [isLogoutModal, setIsLogoutModal] = useState(false);
  const [isMypageModal, setIsMypageModal] = useState(false);
  const [isJumpModal, setIsJumpModal] = useState(false);
  const [isSignUpModal, setIsSignUpModal] = useState(false);

  const [selectedPkg, setSelectedPkg] = useState<PkgType>('pkg1');

  const { mutateAsync: checkPkgUser } = useCheckPkgUser();
  const { mutateAsync: fetchOtp } = useFetchOtp();

  const router = useRouter();

  const onRouterMain = () => {
    router.push('/dashboard');
  };

  return (
    <>
      <StyledMainHeader>
        <div className="mh-left">
          <button type="button" onClick={onChangeCollapsed}>
            <Image
              src={collapsed ? menuIcons.menuClose : menuIcons.menuOpen}
              alt="menu_icon"
              width="20"
              height="20"
            />
          </button>

          <div className="logo">
            <Image src={ciImage.logo4s} alt="logo" width={100} height={40} />
            <Image
              src={ciImage.logoSamsungWhite}
              alt="samsung"
              style={{ marginTop: 6 }}
              width={100}
              height={40}
            />
          </div>
        </div>
        <div className="mh-center" onClick={onRouterMain}>
          FGIP 4S RFID Solution
        </div>
        <div className="mh-right">
          <p>Fadhili Gas Increment Project</p>

          <button type="button" className="alarm" onClick={() => setIsJumpModal(true)}>
            <img src={commonImage.exchange} alt="alarm" />
          </button>

          <button type="button" onClick={() => setIsMypageModal(true)}>
            <img src={commonImage.mypage} alt="mypage" />
          </button>

          {/* <button type="button" className="alarm" onClick={onVisibleAlarmModal}>
            <img src={commonImage.alarm} alt="alarm" />
          </button> */}

          <button type="button" onClick={() => setIsLogoutModal(true)}>
            <img src={commonImage.logout} alt="logout" />
          </button>
        </div>
      </StyledMainHeader>

      {/* {isAlarmModal && <Alarm open={isAlarmModal} onClose={onVisibleAlarmModal} />} */}

      {isMypageModal && (
        <BasicModal
          open={isMypageModal}
          onClose={() => setIsMypageModal(false)}
          width={800}
          height={780}
          header={'User Info'}
          body={
            <UserDetail
              isMyPage
              userId={storageService.local.getItem(STORAGE_LOCAL_USER_ID) as string}
              onClose={() => setIsMypageModal(false)}
            />
          }
        />
      )}

      {isLogoutModal && (
        <BasicModal
          header="Logout"
          open={isLogoutModal}
          onClose={() => setIsLogoutModal(false)}
          body={
            <Row style={{ justifyContent: 'center' }}>Would you like to proceed with logout?</Row>
          }
          footer={
            <TextButton
              label={'OK'}
              onClick={(e) => {
                cookieStorage.clearAllCookies();
                router.push('/login');
              }}
            />
          }
        />
      )}

      {isJumpModal && (
        <BasicModal
          header="Move to PKG"
          open={isJumpModal}
          onClose={() => setIsJumpModal(false)}
          height={260}
          body={
            <Column gap="9px">
              <BasicLabel label={'PKG No'} />
              <BasicSelect
                value={selectedPkg}
                options={[
                  { label: 'PKG 1', value: 'pkg1' },
                  { label: 'PKG 4', value: 'pkg4' }
                ]}
                onChange={(e) => {
                  console.log('Selected Package:', e.target.value);
                  setSelectedPkg(e.target.value as PkgType);
                }}
                placeholder="Select Package"
              />
            </Column>
          }
          footer={
            <Row>
              <TextButton
                variant="outlined"
                label={'Close'}
                onClick={() => setIsJumpModal(false)}
              />
              <TextButton
                label={'Save'}
                onClick={() => {
                  checkPkgUser(
                    { data: { pkgValue: selectedPkg } },
                    {
                      onSuccess(data) {
                        console.log('Package check successful:', data);

                        // 해당 패키지에 사용자가 등록되어 있음
                        // otp 를 발급 받아서 해당 패키지로 이동
                        if (data.resultObject) {
                          console.log('User is registered in the selected package.');

                          fetchOtp(
                            { data: { pkgValue: selectedPkg } },
                            {
                              onSuccess(otpData) {
                                console.log('OTP fetched successfully:', otpData);
                                if (!otpData.resultObject) {
                                  console.error('OTP data is empty or invalid.');
                                  return;
                                }

                                const otp = otpData.resultObject;
                                const url = `${otp.pageUrl}/sign-in?otp=${otp.tokenId}&pkgNo=${selectedPkg}`;
                                // const url = `http://localhost:2377/sign-in?otp=${otp.tokenId}&pkgNo=${selectedPkg}`;

                                // OTP 발급 성공 후, 해당 패키지로 이동
                                // router.push(url);
                                if (typeof window !== 'undefined') {
                                  window.open(url, '_blank', 'noopener,noreferrer');
                                  setIsJumpModal(false);
                                }
                              },
                              onError(error) {
                                console.error('Error fetching OTP:', error);
                              }
                            }
                          );
                        }

                        // 해당 패키지에 사용자가 등록되어 있지 않음
                        else {
                          console.log('User is NOT registered in the selected package.');
                          setIsJumpModal(false);
                          setIsSignUpModal(true);
                        }
                      }
                    }
                  );
                }}
              />
            </Row>
          }
        />
      )}

      {isSignUpModal && (
        <SignUp open={isSignUpModal} onClose={() => setIsSignUpModal(false)} pkgNo={selectedPkg} />
      )}
    </>
  );
};
